import { FormControl, FormGroup, FormControlLabel, Checkbox, Box, Tooltip } from "@mui/material";
import CheckBox from "../icons/CheckBox";
import CheckBoxChecked from "../icons/CheckBoxChecked";
import InfoIcon from "../icons/ButtonIcons/InfoIcon";
import { TooltipProps } from "../../../helpers/materialUITheme";

const CheckboxGroup = ({ value, onChange, options }) => {
  // Обработчик изменения чекбокса
  const handleCheckboxChange = (name) => (event) => {
    const isChecked = event.target.checked;
    onChange(name);
  };
  
  return (
    <FormControl component="fieldset" sx={{ width: "100%" }}>
      <FormGroup>
        {options.map((option) => (
          <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
            <FormControlLabel
              key={option.id}
              sx={{ margin: "8px 0px" }}
              control={
                <Checkbox
                  checked={option.id === value}
                  onChange={handleCheckboxChange(option.id)}
                  name={option.name}
                  sx={{
                    borderRadius: 0,
                    mr: "8px",
                    "& .MuiCheckbox-root": { padding: "0px !important" },
                  }}
                  icon={
                    <Box>
                      <CheckBox />
                    </Box>
                  }
                  checkedIcon={
                    <Box sx={{ color: "var(--headers)" }}>
                      <CheckBoxChecked />
                    </Box>
                  }
                />
              }
              label={option.name}
            />
            <Tooltip title={option.tooltip} componentsProps={TooltipProps} arrow>
              <Box>
                <InfoIcon />
              </Box>
            </Tooltip>
          </Box>
        ))}
      </FormGroup>
    </FormControl>
  );
};

export default CheckboxGroup;
